export default "__VITE_ASSET__DFrDjHsf__"